var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.qrCodeSrc)?_c('img',{attrs:{"src":_vm.qrCodeSrc}}):_vm._e(),_vm._v(" "),_c('RequestTotp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }